export default "__VITE_ASSET__0mPYMbQd__"